<template>
  <div class="prodects">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      :loading-text="anchorLan.loading"
      :error-text="anchorLan.error"
      @load="getGoods"
    >
      <!-- :finished-text="anchorLan.noMore" -->
      <ul v-if="goods && goods.length">
        <li
          v-for="(item, index) in goods"
          :key="item.id"
          @click="toGoodsDetail(item)"
        >
          <div class="prodects-item global_pointer">
            <div class="goods-img">
              <img
                v-lazy="
                  handleImg({
                    url: item.coverImgKey.url,
                    width: 340,
                    height: 340,
                  })
                "
                alt=""
              />
            </div>
            <div class="goods-intro">
              <h3 class="goods-intro-name">
                {{ item.nameEn }}
              </h3>
              <div class="anchor">
                <img :src="storeInfo.logo.url" alt="" />
                <span>{{ storeInfo.nameEn }}</span>
              </div>

              <div class="goods-price">
                <div class="price">
                  <span class="truth-price" v-if="!item.grouponActivityInfo">
                    {{
                      `${item.miniAmountMoney.symbol}${priceSeparator(
                        Number(item.miniAmountMoney.number).toFixed(2)
                      )}`
                    }}
                  </span>
                  <!--活动价-->
                  <span class="truth-price" v-if="item.grouponActivityInfo">
                    {{
                      `${
                        item.grouponActivityInfo.minActivityPriceMoney.symbol
                      }${priceSeparator(
                        Number(
                          item.grouponActivityInfo.minActivityPriceMoney.number
                        ).toFixed(2)
                      )}`
                    }}
                  </span>
                   <div
                    v-show="
                      item.userDiscountStr &&
                      !item.canSecKill &&
                      !item.canGroupon
                    "
                    class="userDiscount"
                  >
                    {{ item.userDiscountStr }}
                  </div>

                  <div class="origin-price-layout">
                    <span
                    v-if=" item.miniOrgAmountMoney "
                    class="origin-price"
                    >{{
                      `${item.miniOrgAmountMoney.symbol}${priceSeparator(
                        Number(item.miniOrgAmountMoney.number).toFixed(2)
                      )}`
                    }}</span
                  >
                  <!--活动价显示的原价-->
                  <span
                    v-if="
                      item.grouponActivityInfo &&
                      Number(
                        (item.grouponActivityInfo.minActivityPriceMoney || {})
                          .number
                      ) < Number((item.miniAmountMoney || {}).number)
                    "
                    class="origin-price"
                    >{{
                      `${item.miniAmountMoney.symbol}${priceSeparator(
                        Number(item.miniAmountMoney.number).toFixed(2)
                      )}`
                    }}</span
                  >
                  </div>
                </div>
               
              </div>

              <!-- <prodects-button
                :prodects="item"
                :index="index"
                @collectGoods="collectGoods"
              ></prodects-button> -->
            </div>
          </div>
        </li>
      </ul>
      <van-empty
        v-if="showEmpty"
        class="custom-image"
        image="https://fr-static.shopshops.top/20210401/empty.e9e968f9158374aa.png"
        image-size="90"
        description=""
      />
    </van-list>
  </div>
</template>
<script>
import api from "@/api/api_list";
import { priceSeparator } from "@/utils/formatUtil";
import { List, Empty } from "vant";
import ProdectsButton from "./prodects-button";
export default {
  components: {
    ProdectsButton,
    [List.name]: List,
    [Empty.name]: Empty,
  },
  props: {
    anchorInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    storeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      goods: [],
      pages: 0,
      page: 0,
      priceSeparator,
      error: false,
      loading: false,
      finished: false,
      anchorLan: this.$t("message.anchor"),
      collecting: false,
      goodsLan: this.$t("message.goods"),
      showEmpty: false,
    };
  },
  methods: {
    async getGoods() {
      if (this.finished) return;
      this.page++;
      try {
        const { code, result } = await api.get_store_recommend_goods({
          storeId: this.storeInfo.id,
          pageNum: this.page,
          pageSize: 10,
        });
        this.loading = false;
        if (code) return;
        this.pages = result.pages;
        this.goods = [...this.goods, ...result.data];
        if (!this.goods.length) {
          this.showEmpty = true;
        }
        if (this.page >= result.pages) {
          this.finished = true;
        }
      } catch (e) {
        this.error = true;
        this.loading = false;
        console.log(e);
        if (!this.goods.length) {
          this.showEmpty = true;
        }
      }
    },
    discount(item) {
        if(item.userDiscount) {
          if( this.$i18n.locale === 'en' ){
            // return `-${100 - Math.round(Number(item.userDiscount) * 100)}%`
            return `${100 - Math.round(Number(item.userDiscount) * 100)}% Off`
          }else{
            return item.userDiscountStr;
          }
        }
    },
    // discount(item) {
    //   if (item.userDiscount) {
    //     return `-${100 - Math.round(Number(item.userDiscount) * 100)}%`;
    //   }
    // },
    async collectGoods(item, index) {
      // 收藏商品
      if (this.collecting) {
        // 防止重复点击
        return;
      }
      this.collecting = true;
      let data = {
        goodsName: item.name,
        goodsId: item.id,
        goodsImageUrl: item.coverImgKey,
        goodsMoneySymbol: item.miniAmountMoney && item.miniAmountMoney.symbol,
        goodsMoneyNumber: item.miniAmountMoney && item.miniAmountMoney.number,
        netAccount: "",
      };
      try {
        if (!item.isLike) {
          // 收藏
          const { code } = await api.collect_goods({
            merchandiseId: item.id,
          });
          if (code === 0) {
            this.$toast(this.goodsLan.collectGoods);
            this.$set(this.goods[index], "isLike", 1);
          }
        } else {
          // 取消收藏
          const { code } = await api.cancel_collect_goods({
            likeId: item.id,
          });
          if (code === 0) {
            this.$toast(this.goodsLan.collectTips);
            this.$set(this.goods[index], "isLike", 0);
          }
        }
      } catch (e) {
        console.error("collectErr:", e);
        /*global window*/
        window.__bl && window.__bl.error(`收藏商品错误：${JSON.stringify(e)}`);
      }
      this.collecting = false;
    },
    toGoodsDetail(good) {
      this.$router.push({
        path: "/app/goods_detail",
        query: {
          goodsId: good.id,
          source: 3
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.prodects {
  color: #ffffff;
  background: #000000;
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 6.5px;
    li {
      width: 50%;
      padding: 6.5px;
      .prodects-item {
        position: relative;
        text-align: left;
        border-radius: 8px;
        background: rgb(29, 29, 29);
        overflow: hidden;
      }
      .goods-img {
        position: relative;
        img {
          width: 100%;
          vertical-align: top;
        }
      }
      .goods-intro {
        padding: 8px 12px 12px;
        &-name {
          color: rgba(255, 255, 255, 0.9);
          font-size: 14px;
          line-height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-family: "TradeGothicLT";
        }
        .anchor {
          display: flex;
          align-items: center;
          margin-top: 7px;
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px; 
            margin-left: 4px;
            font-family: "TradeGothicLT";
          }
        }

        .goods-price {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          text-align: left;
          .userDiscount {
            position: absolute;
            left: 0;
            top: 0;
            display: inline-block;
            font-size: 10px;
            color: #ffffff;
            background: rgb(246, 99, 85);
            padding: 0.5px 5px;
            border-radius: 20px 20px 20px 0;
            line-height: 16px;
            height: 16px;
          }
          .price {
            padding: 8px 0px;
          }
          .truth-price {
            color: rgb(252, 91, 63);
            font-size: 16px;
            font-family: "TradeGothicLT-Bold";
            i {
              font-size: 10px;
            }
          }
          .origin-price-layout{
            line-height: 10px;
            min-height: 10px;
          }
            
          .origin-price {
            color: rgb(216, 216, 216);
            font-size: 10px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>